import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { IMAGES, LINKS } from '../data/site';
const APPLICATIONS = ['Automotive', 'Motorcycle', 'Aircraft', 'Architectural', 'Sculptural'];
export function CustomWork() {
  return <section className="border-t border-steel-200 bg-cream" aria-labelledby="custom-heading" data-id="element-68" data-mp="1owp9sno24f14">
      <div className="mx-auto grid max-w-[1240px] gap-8 px-5 py-16 sm:px-8 lg:grid-cols-2 lg:gap-16 lg:py-20" data-id="element-69" data-mp="1k08hridqlgir">
        <div className="min-w-0" data-id="element-70" data-mp="w9uyag97wpzs">
          <p className="font-display text-[13px] uppercase tracking-eyebrow text-fred" data-id="element-71" data-mp="s7rcaxoxa309">Custom fabrication</p>
          <h2 id="custom-heading" className="mt-4 font-display text-[40px] font-bold uppercase leading-[0.95] text-charcoal sm:text-[52px]" data-id="element-72" data-mp="167965rh2s6gh">
            From a single panel
            <br data-id="element-73" data-mp="2hm66vymmgk3o" />
            to a complete body.
          </h2>

          <figure className="mt-7 w-full" data-id="element-74" data-mp="2hosbbpe7ujho">
            <img src={IMAGES.customCoachbuilding} alt="Unpainted metal bodywork on a classic open-top car with wire wheels and whitewall tires." loading="lazy" width={1862} height={845} className="h-auto w-full object-contain" data-id="element-75" data-mp="2coe3a7cm79jn" />
            <figcaption className="mt-3 text-[13px] leading-snug text-steel-600" data-id="element-76" data-mp="275ae490r7exo">
              Custom coachbuilding by Fournier Enterprises.
            </figcaption>
          </figure>
        </div>

        <div className="min-w-0 lg:pt-9" data-id="element-77" data-mp="1ehmxt66inagu">
          <p className="max-w-[52ch] text-[16px] leading-relaxed text-steel-600 sm:text-[17px]" data-id="element-78" data-mp="1jf6cg774lp9b">
            We shape one-off and small-quantity work in aluminum and mild steel — panels, fuel tanks, hood
            scoops, fenders and full coachbuilding, built in the shop by hand and by wheel.
          </p>

          <ul className="mt-6 grid list-disc grid-cols-2 gap-x-6 gap-y-3 pl-5 text-[16px] leading-relaxed text-charcoal marker:text-fred" data-id="element-79" data-mp="vpu23402bb5f">
            {APPLICATIONS.map(item => <li key={item} className="pl-1" data-id="element-80" data-mp="snzecz6mw6c4">{item}</li>)}
          </ul>

          <div className="mt-7 border-t border-steel-200 pt-6" data-id="element-81" data-mp="slwhpwaz7eyf">
            <p className="max-w-[52ch] text-[15px] leading-relaxed text-steel-600" data-id="element-82" data-mp="no4pf16f5qtp">
              To get an estimate moving, tell us the material, dimensions, quantity and timing, and send any
              drawings or photos you have. The more we can see, the more useful our answer will be.
            </p>

            <div className="mt-6 flex flex-wrap items-center gap-x-6 gap-y-3" data-id="element-83" data-mp="9pn2h5oc8icu">
              <a href={LINKS.contact} className="inline-flex min-h-[52px] items-center bg-charcoal px-7 font-display text-[20px] uppercase tracking-[0.06em] text-white transition-colors duration-150 ease-out hover:bg-fred" data-id="element-84" data-mp="4r3g545u14jy">
                Discuss Your Project
              </a>
              <a href={LINKS.fabrication} className="inline-flex min-h-[44px] items-center gap-2 text-[15px] text-charcoal underline decoration-steel-200 underline-offset-4 transition-colors duration-150 ease-out hover:decoration-fred" data-id="element-85" data-mp="1v0mwruao7mbd">
                See custom metal shaping
                <ArrowRightIcon aria-hidden="true" className="h-4 w-4 text-fred" data-id="element-86" data-mp="1om7k4cddi7ts" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>;
}